/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgFlatbedTowing56(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={56}
      height={56}
      fill='none'
      viewBox='0 0 56 56'
      {...props}
    >
      <g fill='currentColor' fillRule='evenodd'>
        <path d='M32.08 11.2a2.711 2.711 0 014.626-1.916c.508.508.794 1.195.794 1.916v1.49h6.153l3.025 15.97 2.244 1.23 4.28 2.345a3.262 3.262 0 011.7 2.866v11.95h-7.134a6.912 6.912 0 01-13.636 0H.07v-1.5h27.641v-4.48H.91v-1.5h26.802V12.69h4.369V11.2zM29.21 45.552V29.02h10.427v1.938h1.5v-7.865h-1.5v4.427H29.211V14.19h13.2l2.925 15.445.311.171 2.554 1.4 4.282 2.345c.567.31.918.903.918 1.55v10.45h-5.55a6.91 6.91 0 00-13.802 0h-4.838zm16.796-16.404l-.36.658.36-.658zM33.58 12.69V11.2a1.211 1.211 0 012.065-.856c.227.227.355.534.355.856v1.49h-2.42zm1.96 33.23a5.41 5.41 0 1110.82 0 5.41 5.41 0 01-10.82 0z' />
        <path d='M-17.014 21.206a8.565 8.565 0 018.533-7.819h10.15c1.728 0 3.35.843 4.342 2.258l2.667 3.808 1.28 1.828 8.728 1.877a7.159 7.159 0 015.653 6.998v4.995l-9.753.014a4.66 4.66 0 01-9.193.013l-27.163.04v-.75h-.75v-5.225c0-1.868.812-3.636 2.227-4.853l.002-.001 2.342-2.007.871-.748v-.428h.064zm34.706 7.763l.323.14.726.31c.88.375 1.827.57 2.786.57h1.31l.002.167v3.497l-8.25.012a4.66 4.66 0 00-9.204.013l-26.406.04v-4.475c0-1.43.622-2.783 1.706-3.715.786-.672 1.662-1.424 2.342-2.007l.95-.815H9.449l8.922 1.919a5.66 5.66 0 014.218 3.864h-1.062a5.6 5.6 0 01-2.197-.45l-.002-.001-.721-.308-.321-.138-.594 1.377zm-8.18-7.014v-.003.003zm-1.438-.75l-.625-.892-2.667-3.807a3.803 3.803 0 00-3.113-1.62h-10.15a7.065 7.065 0 00-7.026 6.32H8.074zM6.829 34.403a3.16 3.16 0 116.319 0 3.16 3.16 0 01-6.32 0z' />
      </g>
      <defs>
        <clipPath id='flatbed-towing-56_svg__clip0'>
          <path fill='#fff' d='M0 0h56v56H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgFlatbedTowing56;
